export const attachS3Url = (path: string): string => {
  return `https://ik.imagekit.io/raqwvm0o0/` + path;
};
